import { useEffect, useState } from "react";

import dayjs from "@/lib/helpers/dayjs";
import { durationToString } from "@/utils/momentUtils";

// startTime is epoch ms so callers don't need to share a date library with this hook
export function useCallTimer(startTime: number): string {
  const [timer, setTimer] = useState("00:00");

  useEffect(() => {
    const start = dayjs(startTime);

    const timerInterval = setInterval(() => {
      const current = dayjs();

      if (current.isAfter(start)) {
        setTimer(durationToString(dayjs.duration(current.diff(start))));
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, [startTime]);

  return timer;
}
